import { stringIsNullOrEmpty } from "src/common/utilities";
import { ButtonElement } from "../components/button/button-viewModel";
import { CheckboxElement } from "../components/checkbox/checkbox-viewModel";
import { ClientFilterTableElement } from "../components/clientFilterTable/clientFilterTable-viewModel";
import { ServerFilteringTableViewModel } from "../components/clientFilterTable/serverFilteringTable-viewModel";
import { ComboViewModel } from "../components/combo/combo-viewModel";
import { ContentElement } from "../components/content/content-viewModel";
import { DataViewModel } from "../components/date/data-viewModel";
import { DummyPlaceHolderElement } from "../components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { DummyTablePlaceHolderComponentElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TdElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/td/td-viewModel";
import { GridViewModel } from "../components/grid/grid-viewModel";
import { HrViewModel } from "../components/hr/hr-viewModel";
import { InputElement } from "../components/input/input-viewModel";
import { ListViewModel } from "../components/list/list-viewModel";
import { LoadingViewModel } from "../components/loading/loading-viewModel";
import { MultiLineInputViewModel } from "../components/multiLineInput/multiLineInput-viewModel";
import { ScrollViewModel } from "../components/scroll/scroll-viewModel";
import { SpanElement } from "../components/span/span-viewModel";
import { ElementProperty, FormBuilderElement, IFormBuilderElementVisitor } from "../structure/element";
import { BindingPropertyValue, IElementPropertyValueVisitor, StaticPropertyValue, UnsetPropertyValue } from "../structure/propertyValue";
import { FilesListViewModel } from "../components/filesList/filesList-viewModel";

export class HtmlSerializer implements IFormBuilderElementVisitor,IElementPropertyValueVisitor{
    
    
    
    private result:string[];


    public serialize(element:FormBuilderElement):string{
        if(element==null)
            return '';
        let result = this.serializeAsArray(element);
        return result.join('');
    }    
    private serializeAsArray(element:FormBuilderElement):string[]{
        this.result = [];

        <string><any>element.Accept(this,null);
        return this.result;

    }
    
    VisitGrid(arg0: GridViewModel, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="grid"',...this.convertProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitDummyPlaceHolder(arg0: DummyPlaceHolderElement, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        
        if(arg0.TemplateType=="Content"){
            let properties = this.convertProperties(arg0,["TemplateType"]);
            let className = '';
            if(properties.filter(x=>x.startsWith('data-bcustom-width') || x.startsWith('data-bcustom-height'))){
                className = 'class="popup-size-specifier"';
            }
            this.result.push(...['<div id="3169b9c8-8886-4885-8962-b197e3c391b4"',className,...properties,'>',...elementsData,'</div>']);
        }else if(arg0.TemplateType=='Combo'){
            this.result.push(...['<select><option id="3169b9c8-8886-4885-8962-b197e3c391b4">',...elementsData,'</option></select>']);
        }else if(arg0.TemplateType=="Table"){
            this.result.push(...elementsData);

        }
        return null;
    }
    VisitInput(arg0: InputElement, parameter: object): object {
        this.result.push(...['<div data-b-component="input"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitContent(arg0: ContentElement, parameter: object): object {
        this.result.push(...['<div data-b-component="content"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitComboBox(arg0: ComboViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="combo"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitSpan(arg0: SpanElement, parameter: object): object {
        this.result.push(...['<span ',...this.convertProperties(arg0),'>',...this.convertContentProperties(arg0),'</span>'])
        return null;
    }
    VisitDummyTablePlaceHolderComponentElement(arg0: DummyTablePlaceHolderComponentElement, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<table><tbody><tr id="3169b9c8-8886-4885-8962-b197e3c391b4">',...elementsData,'</tr></tbody></table>'])
        return null;
    }
    VisitTdElement(arg0: TdElement, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<td ',...this.convertProperties(arg0),'>',...elementsData,'</td>'])
        return null;    
    }
    VisitClientFilterTable(arg0: ClientFilterTableElement, parameter: object): object {
        let columnInfo = '';
        if(stringIsNullOrEmpty(arg0.Columns)==false){
            let columns = arg0.Columns;
            let info = JSON.parse(columns);
            info.forEach(x=>{
                columnInfo = columnInfo + `<th data-b-component="${x.type}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-name="${x.title}"></th>`
            })
        }
        this.result.push(...['<table data-b-component="clientfiltertable"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertProperties(arg0,['Columns']),'><thead>',columnInfo,'</thead><tbody>','</tbody></table>'])
        return null;
    }
    VisitServerFilterTable(arg0: ServerFilteringTableViewModel, parameter: object): object {
        let columnInfo = '';
        if(stringIsNullOrEmpty(arg0.Columns)==false){
            let columns = arg0.Columns;
            let info = JSON.parse(columns);
            info.forEach(x=>{
                columnInfo = columnInfo + `<th data-b-component="${x.type}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-name="${x.title}"></th>`
            })
        }
        this.result.push(...['<table data-b-component="serverfiltertable"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertProperties(arg0,['Columns']),'><thead>',columnInfo,'</thead><tbody>','</tbody></table>'])
        return null;
    }
    
    VisitButton(arg0: ButtonElement, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="button"',...this.convertProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitCheckBox(arg0: CheckboxElement, parameter: object): object {
        this.result.push(...['<div data-b-component="checkbox"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitDate(arg0: DataViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="date"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitHr(arg0: HrViewModel, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="hr"',...this.convertProperties(arg0),'><div>',...elementsData,'</div></div>'])
        return null;
    }
    VisitList(arg0: ListViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="list"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertProperties(arg0),'></div>'])
        return null;
    }
    VisitLoading(arg0: LoadingViewModel, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="loading"',...this.convertProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitMultiLineInput(arg0: MultiLineInputViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="multilineinput"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    VisitScroll(arg0: ScrollViewModel, parameter: object): object {
        let elementsData = arg0.children.map(x=>new HtmlSerializer().serializeAsArray(x)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="scroll"',...this.convertProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitFilesList(arg0: FilesListViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="fileslist"',...this.convertProperties(arg0),'>','</div>'])
        return null;
    }
    





    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        let elementPropery = <ElementProperty>parameter
        return [elementPropery.property.attributeName,'="',arg0.getValue(),'"'];
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        let elementPropery = <ElementProperty>parameter
        return [elementPropery.property.attributeName,'="',arg0.getValue(),'"'];
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return null;
    }
    

    private convertProperties(element:FormBuilderElement,omittingPropertyNames:string[]=[]):string[]{
        let result = [];
        let visitor = this;
        element.properties.forEach(x=>{
            if(x.property.canBeContent==false && omittingPropertyNames.indexOf(x.property.name)==-1){
                let value = x.elementPropertyValue.Accept(visitor,x);
                if(value!=null){
                    result.push(...[value]);                    
                }
            }
        });
        return result.flatMap(x=>x);
    }
    private convertContentProperties(element:FormBuilderElement):string[]{
        var contentProperties = element.properties.filter(x=>x.property.canBeContent==true);
        if(contentProperties.length==1){
            let visitor = new propertyValueExtractor();
            let value = <string[]>contentProperties[0].elementPropertyValue.Accept(visitor,null);
            return [...value];
        }
        return [];
    }
} 

class propertyValueExtractor implements IElementPropertyValueVisitor{
    
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        return [arg0.getValue()];
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        return [arg0.getValue()];
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return [];
    }
}